import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function UpcomingPerformance() {
  const ref = useScrollReveal<HTMLDivElement>(0.1, 'fade-up');

  return (
    <section className="relative bg-brand-gradient px-6 md:px-10 lg:px-16 py-24 md:py-32 lg:py-40">
      <div ref={ref} className="max-w-6xl mx-auto">
        {/* Label */}
        <div className="inline-flex items-center gap-3 mb-12 md:mb-16">
          <span className="block w-6 h-[1px] bg-accent-400/60" />
          <span className="text-accent-400/80 text-xs tracking-[0.2em] uppercase font-medium">
            Upcoming Performance
          </span>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-end">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-50 leading-tight">
              Brahms<br />Requiem
            </h2>
            <div className="mt-8 space-y-2">
              <p className="text-lg md:text-xl text-foreground-200 font-heading italic">
                Soloist
              </p>
              <p className="text-sm tracking-[0.15em] uppercase text-accent-400/80 font-medium">
                November 8, 2026
              </p>
              <p className="text-foreground-400 text-sm">
                Kilgore, TX
              </p>
            </div>
            <a
              href="https://royperryfoundation.org/2026-festival/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 mt-8 group cursor-pointer"
            >
              <span className="text-foreground-200 text-sm tracking-[0.12em] uppercase group-hover:text-foreground-50 transition-colors duration-300 whitespace-nowrap">
                Learn More
              </span>
              <span className="w-8 h-8 rounded-full border border-foreground-50/20 flex items-center justify-center group-hover:border-foreground-50/50 group-hover:scale-110 transition-all duration-300">
                <i className="ri-arrow-right-up-line text-foreground-50 text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"></i>
              </span>
            </a>
          </div>

          {/* Dramatic large date */}
          <div className="flex flex-col items-start lg:items-end">
            <div className="flex items-baseline gap-3 md:gap-5">
              <span className="text-[9rem] md:text-[14rem] lg:text-[16rem] font-heading text-foreground-50 leading-none tracking-tight select-none">
                8
              </span>
              <div className="flex flex-col pb-2 md:pb-4">
                <span className="text-lg md:text-2xl lg:text-3xl text-foreground-100 tracking-[0.15em] uppercase font-medium">
                  November
                </span>
                <span className="text-sm md:text-lg lg:text-xl text-foreground-200/70 tracking-wider">
                  2026
                </span>
              </div>
            </div>
            <p className="text-foreground-400/60 text-xs tracking-[0.15em] uppercase mt-4 lg:text-right">
              East Texas Pipe Organ Festival &middot; Kilgore, TX
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}